import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrPartFamilyService, CtwrProcessService } from '../../../ctwr.service';

@Component({
  selector: 'app-part-familes',
  templateUrl: './part-familes.component.html',
  styleUrls: ['./part-familes.component.scss']
})
export class PartFamilesComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly partFamilyService: CtwrPartFamilyService,
    private readonly processService: CtwrProcessService,
  ) {
    super();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.controls.edit = false;
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ProcessId: ['', Validators.required],
    })
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.formDialog.initilize("Part Family", this.editForm, this.formDialogTabs);
    this.processService.read();

  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.editForm.get('Name').enable();
    this.formDialog.next(this.editDataItem);
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.partFamilyService.read('') :
      Promise.resolve(this.partFamilyService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.editForm.get('Name').disable();
    this.formDialog.next(this.editDataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    return this.partFamilyService.save(dataItem, isNew, '', false);
  }

  delete(dataItem: any): Promise<any> {
    return this.partFamilyService.remove(`/${dataItem.Id}`, false);
  }

  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
    {
      field: 'ProcessName',
      title: 'Process'
    }
  ]

  formControls = [
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      textField: 'Description',
      valueField: 'Id',
      placeholder: '',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
    },
    {
      type: 'combobox',
      title: 'Process',
      name: 'ProcessId',
      textField: 'Name',
      valueField: 'Id',
      service: this.processService,
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Part Family",
      selected: true,
      formControls: this.formControls
    },
  ]
}
